import { TechnologyName } from '~/common/enums/enums';
import typescriptIcon from '~/assets/img/technologies/typescript.svg';
import reactIcon from '~/assets/img/technologies/react.svg';
import reduxIcon from '~/assets/img/technologies/redux.svg';
import nodejsIcon from '~/assets/img/technologies/nodejs.svg';
import postgresqlIcon from '~/assets/img/technologies/postgresql.svg';
import angular from '~/assets/img/technologies/angular.svg';
import awsIcon from '~/assets/img/technologies/aws.svg';
import azureIcon from '~/assets/img/technologies/azure.svg';
import dockerIcon from '~/assets/img/technologies/docker.svg';
import dotnetIcon from '~/assets/img/technologies/dotnet.svg';
import fastifyIcon from '~/assets/img/technologies/fastify.svg';
import flutterIcon from '~/assets/img/technologies/flutter.svg';
import sqlIcon from '~/assets/img/technologies/ms-sql.svg';
import nextjsIcon from '~/assets/img/technologies/nextjs.svg';
import openaiIcon from '~/assets/img/technologies/openai.svg';
import prismaIcon from '~/assets/img/technologies/prisma.svg';
import rabbitmqIcon from '~/assets/img/technologies/rabbitmq.svg';
import redisIcon from '~/assets/img/technologies/redis.svg';
import signalrIcon from '~/assets/img/technologies/signalr.svg';
import stripeIcon from '~/assets/img/technologies/stripe.svg';
import socketdotioIcon from '~/assets/img/technologies/socketdotio.svg';

const technologyNameToDetails: Record<
  TechnologyName,
  { icon: string; label: string }
> = {
  [TechnologyName.TYPESCRIPT]: { icon: typescriptIcon, label: 'Typescript' },
  [TechnologyName.REACT]: { icon: reactIcon, label: 'React' },
  [TechnologyName.REDUX]: { icon: reduxIcon, label: 'Redux' },
  [TechnologyName.NODEJS]: { icon: nodejsIcon, label: 'Node.js' },
  [TechnologyName.POSTGRESQL]: { icon: postgresqlIcon, label: 'PostgreSQL' },
  [TechnologyName.ANGULAR]: { icon: angular, label: 'Angular' },
  [TechnologyName.AWS]: { icon: awsIcon, label: 'AWS' },
  [TechnologyName.AZURE]: { icon: azureIcon, label: 'Azure' },
  [TechnologyName.DOCKER]: { icon: dockerIcon, label: 'Docker' },
  [TechnologyName.DOT_NET]: { icon: dotnetIcon, label: '.NET' },
  [TechnologyName.FASTIFY]: { icon: fastifyIcon, label: 'Fastify' },
  [TechnologyName.FLUTTER]: { icon: flutterIcon, label: 'Flutter' },
  [TechnologyName.MS_SQL]: { icon: sqlIcon, label: 'MS SQL' },
  [TechnologyName.NEXT_JS]: { icon: nextjsIcon, label: 'Next.js' },
  [TechnologyName.OPEN_AI]: { icon: openaiIcon, label: 'OpenAI' },
  [TechnologyName.PRISMA]: { icon: prismaIcon, label: 'Prisma' },
  [TechnologyName.RABBIT_MQ]: { icon: rabbitmqIcon, label: 'RabbitMQ' },
  [TechnologyName.REDIS]: { icon: redisIcon, label: 'Redis' },
  [TechnologyName.SIGNAL_R]: { icon: signalrIcon, label: 'SignalR' },
  [TechnologyName.STRIPE]: { icon: stripeIcon, label: 'Stripe' },
  [TechnologyName.SOCKET_IO]: { icon: socketdotioIcon, label: 'Socket.IO' },
} as const;

export { technologyNameToDetails };
